export const COLORS = {
	black: '#1D1313',
	color2: '#24B694',
	red: '#D22042',
	lemon: '#A3B808',
	light: '#30C4C9',
};

export const FONTS = {
	Bold: 'MuseoSansBold',
	Medium: 'MuseoSansMedium',
	Regular: 'MuseoSansRegular',
	Light: 'MuseoSansLight',
};

const theme = { COLORS, FONTS };

export default theme;
